import { useEffect, useState } from "react";

import { useTimeout } from "./use-timers";

export default function useIsTextExpandable(
  ref: React.RefObject<HTMLElement | null>
) {
  const [isExpandable, setIsExpandable] = useState(false);

  const { start } = useTimeout(() => {
    const { current } = ref;

    if (current) {
      setIsExpandable(current.offsetHeight < current.scrollHeight);
    }
  }, 50);

  useEffect(() => {
    if (ref.current) {
      start();
    }
  }, [ref, start]);

  return isExpandable;
}
